import { contractServiceClient } from '@lib/documentServiceClient';
import { createCrossOrgSnapshotService } from '@workpay/ds-shared/services/crossOrgSnapshotService';

export const dsCrossOrgSnapshotService = createCrossOrgSnapshotService(contractServiceClient);
